import { createClient } from '@/lib/supabase/client'

// Client-side activity tracker for use in browser components
export async function trackActivity(data: {
  activity_type: string
  activity_category: string
  entity_type?: string
  entity_id?: string
  entity_name?: string
  company_id?: string
  contact_id?: string
  subject: string
  description?: string
  user_id?: string
  metadata?: Record<string, any>
}): Promise<void> {
  try {
    const supabase = createClient()
    const { error } = await supabase
      .from('activities')
      .insert([{
        ...data,
        activity_date: new Date().toISOString(),
        created_by: data.user_id || 'system'
      }])

    if (error) {
      // Silently fail - activity tracking shouldn't break the main flow
    }
  } catch (err) {
    // Silently fail
  }
}